module.exports = __webpack_public_path__ + "fd9e23614997b6e9831ab21142531c0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/animals/Lion1.jpg
// module id = 3472
// module chunks = 0